import { Navigate } from 'react-router-dom'
import WalletPage from './WalletPage'
import AssetManagement from './components/AssetsManagement/AssetsManagement'

export const walletRoutes = {
  path: '/wallet',
  name: 'Wallet',
  element: <WalletPage />,
  children: [
    { index: true, element: <Navigate to='all' replace /> },
    {
      path: 'all',
      element: <AssetManagement group='all' />,
    },
    {
      path: 'crypto',
      element: <AssetManagement group='crypto' />,
    },
    {
      path: 'stocks&bonds',
      element: <AssetManagement group='rwa' />,
    },
    {
      path: 'gold',
      element: <AssetManagement group='gold' />,
    },
  ],
}
